// @ts-nocheck
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  ArrowLeft,
  ArrowRight,
  Bot,
  BrainCircuit,
  Cloud,
  FileScan,
  Gavel,
  Layers3,
  Phone,
  ShieldCheck,
} from "lucide-react";
import SeoHead from "./SeoHead";

const SITE_URL = "https://orionintelligence.net";

const colors = {
  bgTop: "#070b18",
  bgBottom: "#101827",
  primary: "#19E6FF",
  text: "#f0f9ff",
  textMuted: "#a7b4c7",
  cardBg: "rgba(15, 23, 42, 0.62)",
  cardBorder: "rgba(255,255,255,0.12)",
};

const iconMap = {
  custom: Layers3,
  ai: BrainCircuit,
  invoice: FileScan,
  legal: Gavel,
  cloud: Cloud,
  mobile: Phone,
};

export const servicePages = {
  "custom-software": {
    icon: "custom",
    eyebrow: "Custom Software Development",
    title: "Custom εφαρμογές για επιχειρήσεις",
    seoTitle: "Custom Software Development στην Ελλάδα | Orion Intelligence",
    description:
      "Σχεδιασμός και ανάπτυξη custom εφαρμογών, CRM/ERP dashboards, SaaS προϊόντων και εσωτερικών εργαλείων για επιχειρήσεις στην Ελλάδα και την Ευρώπη.",
    intro:
      "Φτιάχνω λογισμικό που ταιριάζει στη δική σας διαδικασία, αντί να αναγκάζεστε να αλλάξετε την επιχείρησή σας για να χωρέσει σε ένα έτοιμο εργαλείο.",
    outcomes: [
      "Web εφαρμογές και SaaS προϊόντα από την ιδέα μέχρι το live",
      "CRM, ERP και dashboards για καθημερινή λειτουργία ομάδων",
      "Σύνδεση με πληρωμές, email, ημερολόγια, APIs και υπάρχοντα συστήματα",
      "Καθαρό user experience ώστε η ομάδα να το χρησιμοποιεί εύκολα",
    ],
    goodFor: ["startups", "γραφεία υπηρεσιών", "εμπορικές επιχειρήσεις", "ομάδες με manual διαδικασίες"],
    keywords: ["custom software Ελλάδα", "εφαρμογές για επιχειρήσεις", "web app development", "CRM ERP dashboard"],
  },
  "ai-automations": {
    icon: "ai",
    eyebrow: "AI Automation",
    title: "AI αυτοματισμοί για επιχειρήσεις",
    seoTitle: "AI Αυτοματισμοί για Επιχειρήσεις | Orion Intelligence",
    description:
      "AI automations, chatbots, document processing και workflow automation για επιχειρήσεις που θέλουν λιγότερη χειροκίνητη δουλειά και πιο γρήγορες διαδικασίες.",
    intro:
      "Μετατρέπω επαναλαμβανόμενες εργασίες σε αυτοματισμούς με AI, ώστε η ομάδα σας να χάνει λιγότερο χρόνο σε αντιγραφές, ελέγχους και χειροκίνητη καταχώρηση.",
    outcomes: [
      "AI agents και chatbots για εσωτερική υποστήριξη ή πελάτες",
      "Ανάγνωση εγγράφων, ταξινόμηση αιτημάτων και extraction δεδομένων",
      "Αυτοματισμοί email, CRM ενημερώσεων και reporting",
      "Ασφαλής σύνδεση με τα εργαλεία που ήδη χρησιμοποιείτε",
    ],
    goodFor: ["λογιστήρια", "νομικά γραφεία", "sales teams", "operations teams"],
    keywords: ["AI automations Ελλάδα", "AI για επιχειρήσεις", "workflow automation", "AI chatbot"],
  },
  "invoice-automation": {
    icon: "invoice",
    eyebrow: "Invoice Automation",
    title: "Invoice automation και αναγνώριση παραστατικών",
    seoTitle: "Invoice Automation & OCR API | Orion Intelligence",
    description:
      "Αυτοματοποιημένη ανάγνωση τιμολογίων και παραστατικών με AI/OCR, extraction δεδομένων και API σύνδεση με ERP, λογιστικά ή εσωτερικά συστήματα.",
    intro:
      "Αν λαμβάνετε πολλά τιμολόγια, αποδείξεις ή παραστατικά, μπορώ να αυτοματοποιήσω την ανάγνωση και καταχώρηση των βασικών πεδίων.",
    outcomes: [
      "Ανάγνωση PDF ή εικόνας παραστατικού",
      "Εξαγωγή ΑΦΜ, ποσών, ημερομηνιών, προμηθευτή και γραμμών τιμολογίου",
      "API για σύνδεση με ERP, λογιστικό πρόγραμμα ή dashboard",
      "Validation και review flow για να μειώνονται τα λάθη",
    ],
    goodFor: ["λογιστήρια", "retail", "προμήθειες", "επιχειρήσεις με μεγάλο όγκο παραστατικών"],
    keywords: ["invoice automation", "OCR τιμολογίων", "αναγνώριση παραστατικών", "invoice API"],
  },
  "legal-tech": {
    icon: "legal",
    eyebrow: "Legal Tech",
    title: "Legal tech εργαλεία για δικηγόρους και νομικά γραφεία",
    seoTitle: "Legal Tech Εφαρμογές για Δικηγόρους | Orion Intelligence",
    description:
      "Legal tech εφαρμογές, case management, lawyer CRM, portals και AI εργαλεία για δικηγόρους, νομικά γραφεία και επαγγελματίες υπηρεσιών.",
    intro:
      "Σχεδιάζω εργαλεία που βοηθούν νομικές ομάδες να οργανώνουν υποθέσεις, πελάτες, προθεσμίες και επικοινωνία χωρίς χάος σε email και αρχεία.",
    outcomes: [
      "Case management και lawyer CRM",
      "Ημερολόγια προθεσμιών, reminders και client portals",
      "AI βοηθητικά εργαλεία για ταξινόμηση και αναζήτηση πληροφορίας",
      "GDPR-first σχεδιασμός και έλεγχος πρόσβασης",
    ],
    goodFor: ["δικηγόρους", "νομικά γραφεία", "συμβούλους", "ομάδες compliance"],
    keywords: ["legal tech Ελλάδα", "εφαρμογή για δικηγόρους", "case management", "lawyer CRM"],
  },
  "cloud-apps": {
    icon: "cloud",
    eyebrow: "Cloud Apps & Infrastructure",
    title: "Ασφαλείς cloud εφαρμογές και υποδομές",
    seoTitle: "Cloud Apps και Ασφαλείς Υποδομές | Orion Intelligence",
    description:
      "Cloud εφαρμογές, hosting, APIs, βάσεις δεδομένων, backups, monitoring και security hardening για επιχειρησιακά προϊόντα.",
    intro:
      "Βοηθάω επιχειρήσεις να στήσουν αξιόπιστες cloud εφαρμογές που είναι γρήγορες, ασφαλείς και έτοιμες να μεγαλώσουν όταν μεγαλώσει η χρήση.",
    outcomes: [
      "Cloud hosting, APIs και βάσεις δεδομένων",
      "Backups, monitoring, alerts και production deployments",
      "Security headers, access control και βασικό hardening",
      "Σύνδεση με Stripe, Firebase, Google APIs και τρίτες υπηρεσίες",
    ],
    goodFor: ["SaaS προϊόντα", "internal tools", "mobile app backends", "επιχειρήσεις που θέλουν production υποδομή"],
    keywords: ["cloud apps Ελλάδα", "cloud υποδομές", "secure APIs", "SaaS infrastructure"],
  },
  "mobile-apps": {
    icon: "mobile",
    eyebrow: "Mobile Apps",
    title: "Mobile εφαρμογές για iOS και Android",
    seoTitle: "Mobile App Development για Επιχειρήσεις | Orion Intelligence",
    description:
      "Σχεδιασμός και ανάπτυξη mobile εφαρμογών για επιχειρήσεις, προϊόντα και ομάδες, με σύνδεση σε APIs, payments, dashboards και cloud υποδομές.",
    intro:
      "Φτιάχνω mobile εφαρμογές που δεν είναι απλώς όμορφες, αλλά συνδέονται σωστά με το backend, τα δεδομένα και τις πραγματικές ανάγκες του προϊόντος.",
    outcomes: [
      "Mobile εφαρμογές για πελάτες, ομάδες ή SaaS προϊόντα",
      "Σύνδεση με APIs, λογαριασμούς χρηστών, payments και notifications",
      "Dashboard διαχείρισης για την επιχείρηση",
      "Σχεδιασμός για καθαρή εμπειρία χρήστη σε μικρές οθόνες",
    ],
    goodFor: ["startups", "fitness και sports προϊόντα", "service marketplaces", "επιχειρήσεις με mobile κοινό"],
    keywords: ["mobile app development Ελλάδα", "Android app", "iOS app", "mobile εφαρμογές επιχειρήσεων"],
  },
};

function JsonLd({ page, slug }) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": page.title,
    "serviceType": page.eyebrow,
    "description": page.description,
    "provider": {
      "@type": "ProfessionalService",
      "name": "Orion Intelligence",
      "url": SITE_URL,
      "email": "support@orionintelligence.net",
      "areaServed": ["Greece", "Europe"],
    },
    "areaServed": ["Greece", "Europe"],
    "url": `${SITE_URL}/${slug}`,
  };
}

export default function ServicePage({ slug }) {
  const page = servicePages[slug] || servicePages["custom-software"];
  const Icon = iconMap[page.icon] || Layers3;
  const canonical = `${SITE_URL}/${slug}`;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [slug]);

  return (
    <div
      className="min-h-screen text-white"
      style={{
        background: `radial-gradient(1000px 520px at 0% 0%, rgba(25,230,255,0.14), transparent 62%),
                     radial-gradient(900px 520px at 100% 0%, rgba(192,132,252,0.14), transparent 58%),
                     linear-gradient(${colors.bgTop}, ${colors.bgBottom})`,
      }}
    >
      <SeoHead
        title={page.seoTitle}
        description={page.description}
        canonical={canonical}
        jsonLd={JsonLd({ page, slug })}
      />

      <main className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-10 md:py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-cyan-300 hover:text-cyan-100">
          <ArrowLeft size={16} />
          Orion Intelligence
        </Link>

        <section className="grid lg:grid-cols-[1.1fr,0.9fr] gap-10 items-center pt-12">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-cyan-400/30 bg-cyan-400/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-cyan-200">
              <Icon size={14} />
              {page.eyebrow}
            </div>
            <h1 className="mt-5 text-3xl md:text-5xl font-black leading-tight">
              {page.title}
            </h1>
            <p className="mt-5 text-base md:text-lg leading-relaxed" style={{ color: colors.textMuted }}>
              {page.intro}
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <a
                href="/#contact"
                className="inline-flex items-center gap-2 rounded-2xl px-6 py-3.5 font-bold shadow-lg shadow-cyan-500/20"
                style={{ background: colors.primary, color: "#001018" }}
              >
                Ζητήστε πρόταση
                <ArrowRight size={18} />
              </a>
              <Link
                to="/#products"
                className="inline-flex items-center gap-2 rounded-2xl border border-white/10 px-6 py-3.5 font-bold hover:bg-white/5"
              >
                Δείτε έργα
              </Link>
            </div>
          </div>

          <div className="rounded-2xl border p-6 md:p-8" style={{ background: colors.cardBg, borderColor: colors.cardBorder }}>
            <div className="flex items-center gap-3">
              <span className="rounded-xl bg-cyan-400/10 p-3 text-cyan-300">
                <Bot size={24} />
              </span>
              <div>
                <p className="text-xs uppercase tracking-wider text-slate-400">Τι κερδίζετε</p>
                <h2 className="text-xl font-extrabold">Πρακτικό αποτέλεσμα, όχι απλώς κώδικα</h2>
              </div>
            </div>
            <div className="mt-6 grid gap-3">
              {page.outcomes.map((item) => (
                <div key={item} className="flex gap-3 rounded-xl border border-white/10 bg-white/[0.03] p-4">
                  <ShieldCheck size={18} className="mt-0.5 shrink-0 text-emerald-300" />
                  <span className="text-sm leading-relaxed text-slate-200">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="grid md:grid-cols-2 gap-6 py-14">
          <div className="rounded-2xl border p-6" style={{ background: "rgba(255,255,255,0.04)", borderColor: colors.cardBorder }}>
            <h2 className="text-xl font-extrabold">Για ποιους είναι κατάλληλο</h2>
            <div className="mt-5 flex flex-wrap gap-2">
              {page.goodFor.map((item) => (
                <span key={item} className="rounded-full border border-white/10 bg-white/[0.04] px-3 py-1.5 text-sm text-slate-200">
                  {item}
                </span>
              ))}
            </div>
          </div>

          <div className="rounded-2xl border p-6" style={{ background: "rgba(255,255,255,0.04)", borderColor: colors.cardBorder }}>
            <h2 className="text-xl font-extrabold">Σχετικές ανάγκες που καλύπτει</h2>
            <p className="mt-3 text-sm leading-relaxed" style={{ color: colors.textMuted }}>
              Περιγράφει με απλή γλώσσα τις ανάγκες που συνήθως έχει ένας πελάτης όταν ψάχνει τέτοια λύση.
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {page.keywords.map((item) => (
                <span key={item} className="rounded-full bg-cyan-400/10 px-3 py-1.5 text-xs font-semibold text-cyan-200">
                  {item}
                </span>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
